import { Dialog, DialogBackdrop, DialogPanel, DialogTitle } from '@headlessui/react';

// Sample templates with example data
const TEMPLATES = [
  {
    id: 'budget',
    name: 'Monthly Budget',
    description: 'Track income and expenses',
    blocks: [
      {
        title: 'Income',
        elements: [
          { name: 'Salary', value: '45 000' },
          { name: 'Side income', value: '5 000' },
        ]
      },
      {
        title: 'Fixed Expenses',
        elements: [
          { name: 'Rent', value: '12 000' },
          { name: 'Insurance', value: '1 500' },
          { name: 'Phone & Internet', value: '599' },
          { name: 'Streaming services', value: '299' },
        ]
      },
      {
        title: 'Variable Expenses',
        elements: [
          { name: 'Groceries', value: '4 500' },
          { name: 'Transport', value: '1 200' },
          { name: 'Entertainment', value: '2 000' },
          { name: 'Clothing', value: '800' },
        ]
      }
    ]
  },
  {
    id: 'project',
    name: 'Project Costs',
    description: 'Estimate project expenses',
    blocks: [
      {
        title: 'Materials',
        elements: [
          { name: 'Lumber', value: '3 500' },
          { name: 'Paint & supplies', value: '1 200' },
          { name: 'Hardware', value: '850' },
        ]
      },
      {
        title: 'Labor',
        elements: [
          { name: 'Carpenter (16h)', value: '8 000' },
          { name: 'Electrician (4h)', value: '2 400' },
        ]
      },
      {
        title: 'Other',
        elements: [
          { name: 'Permits', value: '500' },
          { name: 'Delivery', value: '350' },
        ]
      }
    ]
  },
  {
    id: 'shopping',
    name: 'Shopping List',
    description: 'Track shopping with prices',
    blocks: [
      {
        title: 'Groceries',
        elements: [
          { name: 'Milk', value: '25' },
          { name: 'Bread', value: '35' },
          { name: 'Eggs', value: '45' },
          { name: 'Chicken', value: '89' },
          { name: 'Vegetables', value: '120' },
        ]
      },
      {
        title: 'Household',
        elements: [
          { name: 'Dish soap', value: '39' },
          { name: 'Paper towels', value: '55' },
          { name: 'Trash bags', value: '49' },
        ]
      }
    ]
  },
  {
    id: 'empty',
    name: 'Blank',
    description: 'Start from scratch',
    blocks: []
  }
];

export const TemplateDialog = ({ isOpen, onClose, onSelectTemplate }) => {
  const handleSelect = (template) => {
    onSelectTemplate(template);
    onClose();
  };

  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50 text-white">
      <DialogBackdrop className="fixed inset-0 bg-black/70" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <DialogPanel className="border border-white/20 w-full max-w-[600px] rounded-[30px] bg-[#4A4A4A]/10 backdrop-blur-sm p-6">
          <DialogTitle className="font-bold text-xl mb-6 flex items-center gap-3">
            Choose a Template
          </DialogTitle>

          <div className="grid grid-cols-2 gap-3">
            {TEMPLATES.map((template) => (
              <button
                key={template.id}
                onClick={() => handleSelect(template)}
                className="text-left p-4 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 hover:border-white/20 transition-all"
              >
                <h3 className="font-semibold text-white mb-1">{template.name}</h3>
                <p className="text-sm text-gray-400">{template.description}</p>
              </button>
            ))}
          </div>

          <button
            onClick={onClose}
            className="mt-6 w-full py-2 text-gray-400 hover:text-white transition-colors text-sm"
          >
            Cancel
          </button>
        </DialogPanel>
      </div>
    </Dialog>
  );
};
